import React from 'react';
import { Button, Card, Dimmer } from 'tabler-react';
import fetch from '../../support/fetch';
import { status as subscriptionStatus } from '../../support/subscription';
import CardAlert from '../../Components/CardAlert';

class CancelAndUpgradeSubscriptionCard extends React.Component {

    state = {
        showLoader: false,
        alertText: null,
        alertColor: 'danger',
    };

    changeStatus = status => {

        const ok = window.confirm('Deseja realmente continuar com esta ação?\nEsta ação é IRREVERSÍVEL.');

        if (! ok) {
            return;
        }

        this.setState({
            showLoader: true
        });

        let query;

        switch (status) {
            case 'cancel':
                query = `mutation CancelSubscriptionById ($id: ID!) {
                    cancelSubscriptionById (id: $id) {
                        id
                    }
                }`;
                break;

            default:
                break;
        }

        fetch.obj({
            query: query,
            variables: {
                id: this.props.subscription.id
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                this.setState({
                    alertText: res.errors[0].debugMessage
                });
            }

            window.location = `/subscriptions/new`;

            this.setState({
                showLoader: false
            });
        });
    };

    cancelHandler = () => {
        this.changeStatus('cancel');
    };

    render() {

        const { subscription } = this.props;

        const content = () => {
            return (
                <React.Fragment>

                    <p className="mb-0 ">
                        Para aderir a um plano com mais benefícios, é necessário que você cancele sua conta atual.
                        Mas lembre-se! Você tem até 72h para dar continuidade ao processo de upgrade para os planos Light, Premium ou VIP. 
                        Após este prazo, seu plano será cancelado, conforme descrito abaixo
                    </p>
                </React.Fragment>
            );
        };

        return (
            <Card>
                <Card.Header>
                    <h4 className="h4 m-0 text-green">CANCELAR PARA FAZER UPGRADE</h4>
                </Card.Header>

                <Card.Alert color="danger" className="text-uppercase text-center">
                    <strong>Ação Definitiva</strong>
                </Card.Alert>

                <CardAlert color={this.state.alertColor}>{this.state.alertText}</CardAlert>

                <Card.Body>
                    <Dimmer loader active={!subscription} >
                        {
                            subscription &&
                            subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                            content()
                        }

                        {
                            subscription &&
                            subscription.status === subscriptionStatus.STATUS_CANCELED &&
                            <div className="text-center">
                                <p>Esta assinatura está cancelada e não é possível reativá-la.</p>
                            </div>
                        }
                    </Dimmer>
                </Card.Body>

                {
                    subscription &&
                    subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                    <Card.Footer className="text-center">
                        <Button
                            pill
                            color="success"
                            outline={!this.state.showLoader}
                            loading={this.state.showLoader}
                            disabled={this.state.showLoader}
                            onClick={this.cancelHandler}>CONTINUAR PARA O UPGRADE</Button>
                    </Card.Footer>
                }
            </Card>
        );
    }
}

export default CancelAndUpgradeSubscriptionCard;